import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Image } from "react-bootstrap";
import { AddToolTip, ExcelNameExport } from "../../../components";
import { ssnMasking } from "../../../utils";
import { get } from "lodash";
import { dataChangeReport } from "./constant";
import { useDeepEffect, useRequest } from "../../../abstracts";
import { getDataChangeReport } from "../../../services";
import {
  getDataChangeInformationById,
  getDownloadDataChangeReport,
} from "../../../services";
import ExcelImage from "../../../styles/file-spreadsheet.png";
import * as fileSaver from "file-saver";
import InfiniteScroll from "react-infinite-scroller";
// import axios from "axios";
// import { apiDetails } from "../../../services/helpers";

const DataChange = ({ data, payrollId }) => {
  const [element, setElement] = useState(null);
  const [start, setStart] = useState(1);
  const [dataChange, setDataChange] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isScroll, setIsScroll] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [request, setRequest] = useState({
    fileId: payrollId,
    pageNumber: 1,
  });

  const exportReportFile = (data) => {
    getDownloadDataChangeReport(payrollId)
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(blob, "DataChange.xlsx");
      })
      .catch((error) => {});
  };

  // function exportReportFile() {
  //   axios.get(apiDetails.baseUrl.trim() + '/api/v1/Report/DownloadDataChangeReport/1', { responseType: 'arraybuffer' })
  //     .then((response) => {
  //       var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //       fileSaver.saveAs(blob, 'DataChange.xlsx');
  //     });
  // }

  useDeepEffect(() => {
    setIsLoading(true);
    getDataChangeInformationById(request)
      .then((response) => {
        setCount(response.count);
        if (response?.dataChangeReportDetails?.length < 5)
          setStopInfiniteScroll(true);
        if (append) {
          setCount(response.count);
          setDataChange((dataChange) => {
            return [...dataChange, ...response?.dataChangeReportDetails];
          });
        } else setDataChange(response?.dataChangeReportDetails);
        setCount(response.count);
        setIsLoading(false);
      })
      .catch((error) => {
        //Handle Errors
        setIsLoading(false);
      });
  }, [request]);

  const showPopup = () => {
    setModalOpen(true);
  };
  return (
    <div className="parentclass">
      <div className="d-flex justify-content-between align-center">
        <div className="ft-12 grey-text font-weight-500">
          Data Changes in {count} Records
        </div>
        <div className="change-data">
          {/* <ExcelNameExport
            headers={dataChangeReport}
            data={dataChange}
            fileName={"data_change.xls"}
            name="Data Change Report"
          /> */}
          <p className="excel-text" onClick={() => exportReportFile()}>
            <span>Data Change Report</span>
          </p>
          <p onClick={() => exportReportFile()}>
            <div className="image-excel">
              <Image src={ExcelImage} width="14px" />
            </div>
          </p>
        </div>
      </div>
      <div className="payroll_scroll">
        <InfiniteScroll
          pageStart={0}
          loadMore={() => {
            setAppend(true);
            setRequest((request) => {
              return { ...request, pageNumber: request.pageNumber + 1 };
            });
          }}
          hasMore={!stopInfiniteScroll}
          initialLoad={false}
          threshold={100}
          useWindow={false}
          loader={
            <div className="loader" key={0}>
              Loading ...
            </div>
          }
        >
          {dataChange?.map((dataChange) => (
            <div ref={setElement} className="data-change">
              <Row>
                <Col md="3">
                  <p className="ft-14 font-weight-500">
                    {dataChange.employeeSSN}
                  </p>
                  <p className="ft-14 font-weight-500">{dataChange.name}</p>
                </Col>
                <Col>
                  {dataChange.dataChangeDetails.map((item, index) => (
                    <div>
                      <Row>
                        <Col md="3">
                          <p className="ft-12 grey-text font-weight-500">
                            Data changed
                          </p>
                          <p className="ft-14 font-weight-500">
                            {item.fieldName}
                          </p>
                        </Col>

                        <Col md="4">
                          <p className="ft-12 grey-text font-weight-500">
                            Original
                          </p>
                          <p className="ft-14 font-weight-500">
                            {item?.original?.length > 20 ? (
                              <AddToolTip name={item.original}>
                                {item.original.slice(0, 20)}...
                              </AddToolTip>
                            ) : (
                              item.original
                            )}
                          </p>
                        </Col>

                        <Col md="4">
                          <p className="ft-12 grey-text font-weight-500">
                            Changed to
                          </p>
                          <p className="ft-14 font-weight-500">
                            {item?.changedTo?.length > 20 ? (
                              <AddToolTip name={item.changedTo}>
                                {item.changedTo.slice(0, 20)}...
                              </AddToolTip>
                            ) : (
                              item.changedTo
                            )}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Col>
              </Row>
            </div>
          ))}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default DataChange;
